import { cacheTypes, getMethod, postMethod } from "../../../store/api/CommonFunctions";

const BASE_URL = 'api/ApiCredential';
export const  createCredential = async (data)=>{
    const result = await postMethod(`${BASE_URL}/CreateCredential`, data, "CreateCredential");
    return result;
}
export const getPageList = async ()=>{
    const result = await getMethod(`${BASE_URL}/GetPageList`, cacheTypes.Default, "GetPageList");
    return result;
}